<div class="ws-popup-header">
  <div>{{'Definitions' | translate}}</div>

  <div class="actions">
    <button class="close-button" mat-icon-button (click)="closeClicked()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div class="ws-popup-content">
  <div class="ws-popup-body">
    <div class="field-wrapper">
      <div class="input-wrapper">
        <label for="initial"><i class="icon-clock"></i> {{'Calendar start time' | translate}}</label>
        <input matInput id="end_time" type="time" [(ngModel)]="startTime" [ngModelOptions]="{ standalone: true }">
      </div>

      <div class="input-wrapper">
        <label for="initial"><i class="icon-clock"></i> {{'Calendar end time' | translate}}</label>
        <input matInput id="end_time" type="time" [(ngModel)]="endTime" [ngModelOptions]="{ standalone: true }">
      </div>
      <mat-datepicker #datepicker [yPosition]="'below'"></mat-datepicker>
    </div>

  </div>
  <div class="ws-popup-footer">
    <span></span>
    <ws-button [callToActionType]="'primary'" (click)="saveClicked()">{{ 'Save' | translate }}</ws-button>
  </div>
</div>